import React from 'react'

export default function contact() {
    return (
        <div className="container mt-4">
           <div className="row">
            <div className='col-12'>
                <h3 className='roboto-title'>Get In Touch With Us</h3>
                <p>
                    We'd love to hear from you! Whether you need more information about our services, or simply want to connect, we are here to help. Reach out to us through any of the following channels, and our team will get back to you as soon as possible.
                </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 p-3 pb-5">
                <span className='icon-bg'><i className="bx bxcustom bxs-map"></i></span>
                <span className='icon-text'>
                    <b>LOCATION</b> <br/>
                    STARKING INSULATION <br/>
                    Khandve Nagar, Pune - Nagar Road, <br/>
                    Pune-412 207, Maharashtra, India.
                </span>
                
            </div>
            <div className="col-12 col-md-6 col-lg-4 p-3 pb-5">
                <span className='icon-bg'><i className="bx bxcustom bxs-phone"></i></span>
                <span className='icon-text'>
                    <b>PHONE</b> <br/>
                    +91 954 537 0654 <br/>
                    +91 779 856 9110
                </span>
            </div>
            <div className="col-12 col-md-6 col-lg-4 p-3 pb-5">
                <span className='icon-bg'><i className="bx bxcustom bxs-envelope"></i></span>
                <span className='icon-text'>
                    <b>EMAIL</b> <br/>
                    starkinginfo@gmail.com
                </span>
            </div>
            </div>
        </div>
    )
}